module.exports = __webpack_public_path__ + "static/media/oracle-certified-professional-java-se-8-programmer.2b469bf9.png";